import React from 'react';
import { Check, X } from 'lucide-react';

export function TemplateBanner({
  template,
  runningTemplate,
  currentStepIndex,
  onRunAllSteps,
  onShowEmbedModal,
  onExitTemplate,
}) {
  return (
    <div className="template-banner">
      <div className="template-banner-content">
        <div className="template-banner-info">
          <span className="workbench-badge workbench-badge-info">{template.industry}</span>
          <h2>{template.name}</h2>
          <p>{template.description}</p>
          <div className="template-meta">
            <span>{template.steps?.length} steps</span>
            <span>~{template.estimated_time_ms}ms</span>
            <span>${(template.estimated_cost_cents / 100).toFixed(2)}</span>
          </div>
        </div>
        <div className="template-banner-actions">
          <button
            className="workbench-btn workbench-btn-primary"
            onClick={onRunAllSteps}
            disabled={runningTemplate}
          >
            {runningTemplate ? `Running step ${(currentStepIndex || 0) + 1}/${template.steps?.length}...` : 'Run All Steps'}
          </button>
          <button
            className="workbench-btn workbench-btn-secondary"
            onClick={onShowEmbedModal}
          >
            Get Embed Code
          </button>
          <button
            className="workbench-btn workbench-btn-ghost"
            onClick={onExitTemplate}
          >
            Exit Template
          </button>
        </div>
      </div>
    </div>
  );
}

export function TemplateResults({ templateResults, onSelectResult }) {
  return (
    <div className="template-results">
      <h3>Flow Results</h3>
      <div className="template-steps">
        {templateResults.map((result, idx) => (
          <div
            key={idx}
            className={`template-step ${result.passed ? 'passed' : 'failed'}`}
            onClick={() => onSelectResult(result)}
          >
            <div className="template-step-header">
              <span className={`template-step-icon ${result.passed ? 'passed' : 'failed'}`}>
                {result.passed ? <Check size={14} /> : <X size={14} />}
              </span>
              <span className="template-step-num">Step {result.step}</span>
              <span className="template-step-name">{result.name}</span>
            </div>
            <div className="template-step-meta">
              <span>{Math.round(result.execution_time_ms)}ms</span>
              <span className="template-step-primitive">{result.primitive_id}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="template-summary">
        <span>{templateResults.filter(r => r.passed).length}/{templateResults.length} passed</span>
        <span>Total: {Math.round(templateResults.reduce((sum, r) => sum + r.execution_time_ms, 0))}ms</span>
      </div>
    </div>
  );
}
